<template>
    <div>
        <QRCodeVue3
            :value="qvalue"
            :width="qSize"
            :height="qSize"
            :qr-options="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'Q' }"
            :dots-options="{ type: 'square', color: qColor }"
            :corners-square-options="{ type: 'square', color: qColor }"
            :download-options="{ name: 'Mi promoción', extension: 'svg' }"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import QRCodeVue3 from "qrcode-vue3";

/** La documentación se encuentra en:
 * https://www.npmjs.com/package/qrcode-vue3
 * en el componente padre puede llamar los siguientes atributos
 * qvalue="1234" Corresponde al valor del QR
 * :q-size="200" Corresponde al tamaño del qr
 * q-color="#000" Corresponde al color del Qr
 * Ejemplo: <qr-generator qvalue="1234" :q-size="200" />
 */

export type CatalogosState = {
    busquedaEdos: string;
    dataExample: string;
    arrayEstados: [];
    errorEdos: string;
};

export default defineComponent({
    name: "QrGenerator",
    components: {
        QRCodeVue3,
    },
    props: {
        qvalue: {
            type: String,
            default: "",
        },
        qSize: {
            type: Number,
            default: 200,
        },
        qColor: {
            type: String,
            default: "#000",
        },
    },
});
</script>

<style></style>
